import { activeVariantConfig, logger } from '../shared'
import { getStyleFile } from './get-style-file'
import { importStyles } from './import-styles'
import { appendStyleToBody } from './append-style-to-body'

/**
 *
 *
 *
 */
export async function initStyles() {
  try {
    const onexConfig = await activeVariantConfig()
    const stylesScss = getStyleFile(onexConfig)
    const styleCode = await importStyles(stylesScss)
    return appendStyleToBody(styleCode)
  } catch (error) {
    logger.logError(new Error('Could not load styles', { cause: error }))
  }
}
